import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { API_NAMES, ApiServiceBase } from '../api';
import { AssetPrintReceipt } from '~/models/administration/assetPrintReceipt';

@Injectable({
  providedIn: 'root'
})
export class AssetPrintReceiptsService extends ApiServiceBase {

 constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.adminAssets);
}

getPrintReceipt() {
    return this.http.get<AssetPrintReceipt>(this._url());
}

updatePrintReceipts(model: any) {
    return this.client.put(this._url(), model);
}

private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/AssetPrintReceipts${v}`);
}
}
